export default __webpack_public_path__ + "static/media/Blog5.e793264f.png";